import React, { FunctionComponent } from 'react';

import ReactTooltip from 'react-tooltip';

import { rgba } from 'polished';
import styled from 'styled-components';

import LocationsMap from './map';

interface TopLocationsMapProps {
  className?: string;
}

const TopLocationsMap: FunctionComponent<TopLocationsMapProps> = ({
  className,
}) => {
  const [content, setContent] = React.useState<React.ReactNode>();
  return (
    <div className={className || ''}>
      <LocationsMap setTooltipContent={setContent} />
      <ReactTooltip className="tooltip">{content}</ReactTooltip>
    </div>
  );
};

export default styled(TopLocationsMap)`
  .tooltip {
    padding: 20px;
    border-radius: 4px;
    min-width: 160px;
    outline: none !important;
    background-color: ${({ theme }) => theme.colors.differentBackground};
    filter: drop-shadow(
      0px 0px 20px ${({ theme }) => rgba(theme.colors.black, 0.25)}
    );

    &::after {
      border-top-color: ${({ theme }) =>
        theme.colors.differentBackground} !important;
    }
  }
`;
